import React from 'react';
import { Link } from 'gatsby';

import { ArrowFull } from '../../../../../static/icons/arrowFull';
// import { IconExplore } from '../../../../../static/icons/icon-explore';
import { Row } from '../../../atoms/row/Row';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import colors from '../../../../../tailwind.colors';
// import { IconExplore } from '../../../../../static/icons/iconExplore';
// import { Robot } from '../../../../../static/icons/robot';

const SystemGuideCard = ({
  title,
  description,
  href,
  icon,
  handleClick,
  label,
  linkClassName,
  buttonText,
}) => (
  <Link
    to={href}
    className={`relative flex h-auto min-w-80 max-w-sm max-h-60 cursor-pointer transition ease-in-out hover:translate-y-2 hover:scale-110 bg-white rounded-3xl border-l-[15px] border-primary-500 px-2 pt-5 pb-4 shadow-2xl ${linkClassName}`}
    onClick={() => {
      handleClick();
    }}
  >
    <div className="flex flex-[0.3] items-center justify-center">
      {/* <IconExplore /> */}
      {icon}
    </div>
    <Stack className="flex-1 justify-center">
      <Row className="items-center min-w-max mt-1">
        <Typography as="h3" fontVariant="h7" textAlign="left">
          {title ?? ''}
        </Typography>
        <span className="mx-2">
          <ArrowFull color={colors.primary[500]} direction="right" />
        </span>
      </Row>
      <Typography
        fontVariant="md"
        textAlign="left"
        className="!text-customGray-700"
      >
        {description ?? ''}
      </Typography>
      {buttonText && (
        <button
          className="font-bold text-white bg-amber-500 rounded-full w-fit px-4 py-2"
          onClick={() => {
            handleClick();
          }}
        >
          {buttonText}
        </button>
      )}
    </Stack>
    {label && (
      <div className="absolute flex justify-center w-full h-12 bg-transparent -top-6 -left-[7px]">
        <div className="flex flex-row w-fit h-full px-3 gap-1 bg-white shadow-md rounded-[40px] justify-center items-center">
          {/* <IconExplore height={24} width={24} /> */}
          {/* <Robot color="#297FFF" width="3" /> */}
          <Typography
            fontVariant="sm"
            className="w-fit px-2 leading-none !text-primary-800 font-normal"
          >
            {label}
          </Typography>
        </div>
      </div>
    )}
  </Link>
);

export default SystemGuideCard;
